import Color from 'color'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import i18n from '../../../i18n'
import { RoomType } from '../../../models/Room'
import { IStore } from '../../../reducers'
import { getCustomColors } from '../../../reducers/bookingCalendar/selectors/getCustomColors'
import {
  getRoomsPositions,
  withoutRemovedRooms as getRooms,
} from '../../../reducers/bookingCalendar/selectors/rooms'
import { getUserProfile } from '../../../reducers/userObject/selectors/settings'
import { IRoomEditorProps } from './CreateRoom'
import { onSubmitCreate } from './submit'
import validateErrors from './validateErrors'
import validateWarnings from './validateWarnings'
import { IFormValues } from './index'

export default function(formName: string) {
  return reduxForm<IFormValues, IRoomEditorProps>({
    destroyOnUnmount: true,
    enableReinitialize: false,
    form: formName,
    onSubmit: onSubmitCreate(formName),
    validate: validateErrors,
    warn: validateWarnings,
  })
}

const mapStateToProps = () => {
  const rooms = getRooms
  const positions = getRoomsPositions

  return (state: IStore): IRoomEditorProps => {
    const profile = getUserProfile(state)
    return {
      colors: getCustomColors(state),
      initialValues: {
        additionalBeds: 0,
        city: profile.city,
        customColor: Color('#FFF')
          .rgb()
          .toString(),
        description: i18n.t('room_description'),
        doubleBed: 0,
        id_country: profile.idCountry,
        name: `${i18n.t('room')} ${rooms(state).length + 1}`,
        position: positions(state).length,
        post_code: profile.postCode,
        roomSize: 2,
        singleBed: 2,
        street: profile.street,
        title: '',
        type: RoomType.Room,
        widget: 1,
      },
      newRoom: true,
      positions: positions(state),
    }
  }
}

export const withCreateInitialValues = connect(mapStateToProps())
